import { Fragment, type FC } from 'react';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { type AuditFormBackgroundPageViewModel } from './audit-form-background-page.view-model';
import { AuditFormBackgroundPageRenderer } from './audit-form-background-page.renderer';

export type AuditFormBackgroundPageContainerProps =
  ViewModelProps<AuditFormBackgroundPageViewModel> & LoggingContext;

export const AuditFormBackgroundPageContainer: FC<
  AuditFormBackgroundPageContainerProps
> = ({ viewModel }) => {
  const { loadAuditFormState, updateMutationState, form, onSubmit } = viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {loadAuditFormState.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {loadAuditFormState.state === 'success' && (
        <AuditFormBackgroundPageRenderer
          form={form}
          onSubmit={onSubmit}
          isPending={updateMutationState.state === 'pending'}
        />
      )}

      {/* Error */}
      {loadAuditFormState.state === 'error' && (
        <ThrowError error={loadAuditFormState.error} />
      )}

      {/* Mutation error */}
      {updateMutationState.state === 'error' && (
        <ThrowError error={updateMutationState.error} />
      )}
    </Fragment>
  );
};
